import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["navigateTo", "navigationIcon", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SCREEN_CONFIG } from '@config/screenConfig';
import { useCompanyStylesCtx } from '@contexts/CompanyStylesContext/CompanyStylesProvider';
import { useLayoutIsShort, useLayoutIsXS } from '@segments/Responsive/client';
import { WaiterFooter } from '@segments/ScreenLayout';
import * as React from 'react';
import { HeroScreen as SharedHeroScreen } from '~shared/components/HeroScreen/HeroScreen';
import { BaseHeaderContent } from './BaseHeaderContent';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Screen wrapper that renders its children inside a layout with company hero image & info on the top.
 * It also includes the LanguagePicker and WaiterFooter.
 */
export var HeroScreen = function HeroScreen(_ref) {
  var navigateTo = _ref.navigateTo,
      navigationIcon = _ref.navigationIcon,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var isMobile = useLayoutIsXS();
  var isShortScreen = useLayoutIsShort();
  var companyStyles = useCompanyStylesCtx();
  return /*#__PURE__*/_jsx(SharedHeroScreen, _objectSpread(_objectSpread({
    isTabletOrMobile: true,
    isShortScreen: isShortScreen,
    isMobile: isMobile,
    footer: /*#__PURE__*/_jsx(WaiterFooter, {}),
    topLineContent: /*#__PURE__*/_jsx(BaseHeaderContent, {
      navigateTo: navigateTo,
      navigationIcon: navigationIcon
    }),
    maxContentWidth: SCREEN_CONFIG.maxContentWidth,
    promoHeaderText: companyStyles.promoHeaderText,
    heroImageUrl: companyStyles.images.heroImageUrl,
    companyNameLabel: companyStyles.primaryNameLabel,
    companyLogoUrl: companyStyles.images.companyLogoUrl
  }, props), {}, {
    children: children
  }));
};